(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["on-stores"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Loop through all swiper containers
  document.querySelectorAll(".region-swiper").forEach(function (el) {
    new Swiper(el, {
      slidesPerView: 6.5,
      spaceBetween: 16,
        breakpoints: {
        200: {
          spaceBetween: 8,
          slidesPerView: 3.5,
        },
        767: {
            slidesPerView: 6.5,
            spaceBetween: 16,
        },
      }
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const floatingWrapper = document.querySelector(".floting-wrapper");
  const firstSwiper = document.querySelector(".on-stores .region-swiper");

  let lastScrollY = window.scrollY;

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  window.addEventListener("scroll", function () {
    let currentScrollY = window.scrollY;

    // If the first swiper is in view → always hide floating wrapper
    if (isInViewport(firstSwiper)) {
      floatingWrapper.classList.remove("active");
    } else {
      // Scrolling up → show
      if (currentScrollY < lastScrollY) {
        floatingWrapper.classList.add("active");
      }
      // Scrolling down → hide
      else {
        floatingWrapper.classList.remove("active");
      }
    }

    lastScrollY = currentScrollY;
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // Select all slides inside both swipers
  const allStoreBlocks = document.querySelectorAll(".region-swiper .swiper-slide .stores-block");
  allStoreBlocks.forEach(slide => {
    slide.addEventListener("click", function () {

      allStoreBlocks.forEach(inner => {
        inner.classList.remove('active');
      });

      const targetHref = this.getAttribute("href");
      const matchedEl = document.querySelectorAll(`[href="${targetHref}"]`);
      console.log(matchedEl, 'matcehd elllll');
                if (matchedEl.length) {
            matchedEl.forEach((el, i) => {
                el.classList.add('active');
            });
          }
      if (!targetHref) return;

      const targetId = targetHref.replace("#", "");
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        window.scrollTo({
          top: targetEl.offsetTop,
          behavior: "smooth"
        });
      }
    });
  });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stores-region"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".store-regions-blocks-wrapper accordion-element > span");

  accordions.forEach(header => {
    header.addEventListener("click", function () {
      const hash = this.dataset.hash; // e.g. "hong-kong"

      // Push hash into URL without scrolling
      if (hash) {
        history.pushState(null, "", `#${hash}`);
      }
    });
  });

  // On page load → open accordion if URL has hash
  const initHash = window.location.hash.replace("#", "");
  if (initHash) {
    const header = document.querySelector(`.store-regions-blocks-wrapper accordion-element > span[data-hash="${initHash}"]`);
    if (header) {
      header.setAttribute("aria-expanded", "true");
      if (header.nextElementSibling) {
        header.nextElementSibling.style.height = "auto";
      }
      header.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
});




  } catch(e) { console.error(e); }
})();
})();
